import React, { useEffect, useState } from 'react'
import {
	BarChart,
	Bar,
	Cell,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from 'recharts'
import { data, databaseLocation } from '../dummyData'
import './chart.css'
import Axios from 'axios'

export default function ConditionChart({ articleList }) {
	const [globalCounter, setGlobalCounter] = useState([])

	const barColors = ['#1f77b4', '#ff7f0e', '#2ca02c', '#962c28', '#a02c79']

	useEffect(() => {
		//initiliaze
		let counter = [{}]
		articleList.map((article) => {
			counter[0][article.state] = 0
		})

		//count
		const promises = articleList.map((article) => {
			counter[0][article.state] += article.quantity
		})
		const results = Promise.all(promises)
		// console.log(counter)

		//take only bigger manufacturers
		let counter2 = [{ Others: 0 }]
		Object.keys(counter[0]).map((state) => {
			if (counter[0][state] > 0) {
				counter2[0][state] = counter[0][state]
			} else {
				counter2[0]['Others'] += counter[0][state]
			}
		})

		//delete "others" if is null
		if (counter2[0]['Others'] == 0) {
			delete counter2[0].Others
		}
		// console.log(counter2);
		setGlobalCounter(counter2)
	}, [articleList]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{globalCounter.length > 0 && (
				<div className='chart'>
					<h3 className='chartTitle'>Condition Chart</h3>
					<ResponsiveContainer width='100%' height='100%'>
						<BarChart data={globalCounter} margin={{ top: 20 }}>
							{Object.keys(globalCounter[0]).map((manu, index) => {
								return (
									<Bar
										key={manu}
										dataKey={manu}
										fill={barColors[index % 5]}
										label={{ position: 'top' }}
									/>
								)
							})}
							<CartesianGrid strokeDasharray='3 3' />
							<XAxis dataKey='name' />
							<YAxis />
							<Tooltip cursor={{ fill: 'transparent' }} />
							<Legend />
						</BarChart>
					</ResponsiveContainer>
				</div>
			)}
		</>
	)
}
